export default "__VITE_ASSET__Ddl0F5Q6__"